import getClipboardData from './clipboard-data';

export default {
  getClipboardData,
};
